import { createContext, type ReactNode } from 'react';

export interface PanelTitleContextValue {
  panelTitle: ReactNode | null;
  setPanelTitle: (title: ReactNode | null) => void;
}

export const PanelTitleContext = createContext<PanelTitleContextValue | null>(null);
